module.exports = "<div class=\"footer_banner clear\" ng-if=\"main.siteConst.footerTagline.bannerDetails || main.siteConst.footeTagline.banner\">\n  <div class=\"fbanner_img\" ng-if=\"main.siteConst.footerTagline.banner\"><img ng-src=\"{{main.siteConst.footerTagline.banner}}\" alt=\"\"></div>\n  <div class=\"fbanner_details\" ng-if=\"main.siteConst.footerTagline.bannerDetails\" ng-bind-html=\"main.siteConst.footerTagline.bannerDetails\"></div>\n</div>\n<div class=\"get_password\" ng-bind-html=\"main.siteConst.footerTagline.getPassword\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/core_theme_2/src/templates/directives/footerTagline.html
// module id = 156
// module chunks = 0